import React, { useState } from 'react';
import { Target, CheckCircle, BarChart3, AlertCircle } from 'lucide-react';
import PCEList from './PCEList';
import PCEHeader from './PCEHeader';
import ConsumptionViewerpce from './ConsumptionViewerpce';

const PCEManager = ({ 
  pces = [], 
  onRefresh
}) => {
    const [viewingConsumption, setViewingConsumption] = useState(null);

    const stats = {
        total: pces.length,
        connected: pces.filter(p => p.connection_status === 'connected').length,
        pending: pces.filter(p => ['not_connected', 'pending'].includes(p.connection_status)).length,
        errors: pces.filter(p => ['error', 'token_expired'].includes(p.connection_status)).length
    };

    const handleViewConsumption = (pce) => {
        setViewingConsumption(pce);
    };

    return (
        <div className="space-y-4">
            <PCEHeader onRefresh={onRefresh} />

            {/* Statistiques */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-medium text-gray-600">Total PCE</p>
                            <p className="text-xs font-bold text-gray-900">{stats.total}</p>
                        </div>
                        <div className="p-2 bg-green-100 rounded-full">
                            <Target className="w-4 h-4 text-green-600" />
                        </div>
                    </div>
                </div>
                
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-medium text-gray-600">Connectés</p>
                            <p className="text-xs font-bold text-gray-900">{stats.connected}</p>
                        </div>
                        <div className="p-2 bg-green-100 rounded-full">
                            <CheckCircle className="w-4 h-4 text-green-600" />
                        </div>
                    </div>
                </div>
                
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-medium text-gray-600">En attente</p>
                            <p className="text-xs font-bold text-gray-900">{stats.pending}</p>
                        </div>
                        <div className="p-2 bg-yellow-100 rounded-full">
                            <BarChart3 className="w-4 h-4 text-yellow-600" />
                        </div>
                    </div>
                </div>
                
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-medium text-gray-600">Erreurs</p>
                            <p className="text-xs font-bold text-gray-900">{stats.errors}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <AlertCircle className="w-4 h-4 text-red-600" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Liste */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                {pces.length === 0 ? (
                    <div className="p-8 text-center">
                        <Target className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                        <h3 className="text-xs font-medium text-gray-900 mb-2">
                            Aucun PCE configuré
                        </h3>
                        <p className="text-gray-600 text-xs">
                            Aucun Point de Comptage et d'Estimation n'a été trouvé.
                        </p>
                    </div>
                ) : (
                    <PCEList
                        pces={pces}
                        onRefresh={onRefresh}
                        onViewConsumption={handleViewConsumption}
                    />
                )}
            </div>

            {/* Modal de consommation */}
            {viewingConsumption && (
                <ConsumptionViewerpce
                    pce={viewingConsumption}
                    onClose={() => setViewingConsumption(null)}
                />
            )}
        </div>
    );
};

export default PCEManager;
